
const categories = [
    {
        id: 1,
        name: "Transport",
        description: "Transportation spending details like taxi, bus, airplane, etc."
    },
    {
        id: 2,
        name: "Groceries",
        description: "Grocery spending details like milk, fruits, meat, juice."
    },
    {
        id:3,
        name:"Shopping",
        description:"Clothes and acessories shopping."
    },
    {
        id:4,
        name:"Travel",
        description:" "
    },
    {
        id:5,
        name:"Health",
        description:" "
    },
    {
        id:6,
        name:"Subscriptions",
        description:" "
    },
    {
        id:7,
        name:"Alcohol",
        description:" "
    }
    

]

export default categories;